export const markString = (searchStr, str) => {
	str = escapeHTML(str);
	if (!searchStr || searchStr.length < 1 || !str) {
		return str;
	}
	if (typeof str !== 'string') {
		str = String(str);
	}
	return str.replace(new RegExp(searchStr, 'gi'), (match) => '<span class="highlightText">' + match + '</span>');
};
export const escapeHTML = (str) =>
	(str + '').replace(
		/[&<>"'`=/]/g,
		(s) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;', '/': '&#x2F;', '`': '&#x60;', '=': '&#x3D;' }[s])
	);
